/// <amd-module name="Test/Analytics/TrendChartCommon/ChartSeries" />
import { ChartSeries } from "Analytics/Shared/ChartSeries/ChartSeries";
import * as CommonResources from "Test/Analytics/Common/Resources";
import * as Resources from "Test/Analytics/TrendChartCommon/Resources";
import { TestReportColorPalette } from "Test/common-util/Common";
import { TestReportDataParser } from "Test/common-util/Common.Utils";
import * as Utils_String from "VSS/Core/Util/String";

export class PassedTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_Passed);
    }

    public get color(): string {
        return TestReportColorPalette.Passed;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class FailedTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_Failed);
    }

    public get color(): string {
        return TestReportColorPalette.Failed;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class InconclusiveTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_Inconclusive);
    }

    public get color(): string {
        return TestReportColorPalette.OtherOutcome;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class AbortedTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_Aborted);
    }

    public get color(): string {
        return TestReportColorPalette.Failed; // Keeping same as failed
    }

    public get values(): number[] {
        return this._data;
    }
}

export class NotExecutedTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_NotExecuted);
    }

    public get color(): string {
        return TestReportColorPalette.NotExecuted;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class ErrorTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_Error);
    }

    public get color(): string {
        return TestReportColorPalette.Failed; // Keeping same as failed
    }

    public get values(): number[] {
        return this._data;
    }
}

export class NotImpactedTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.TestOutcome_NotImpacted);
    }

    public get color(): string {
        return TestReportColorPalette.NotImpacted;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class OtherOutcomeTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.OthersText);
    }

    public get color(): string {
        return TestReportColorPalette.OtherOutcome;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class MultipleOutcomeTestsSeries extends ChartSeries {
    public get name(): string {
        if (this._additionalData) {
            return Utils_String.format(
                Resources.OutcomeResultCountText,
                Utils_String.format(Resources.MultipleOptionsSelectedText, this._additionalData.data1, this._additionalData.data2)
            );
        }
        return "";
    }

    public get color(): string {
        return TestReportColorPalette.TotalTests;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class TotalTestsSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.format(Resources.OutcomeResultCountText, CommonResources.AllText);
    }

    public get color(): string {
        return TestReportColorPalette.TotalTests;
    }

    public get values(): number[] {
        return this._data;
    }
}

export class DurationSeries extends ChartSeries {
    public get name(): string {
        return Utils_String.localeFormat(Resources.DurationSeriesLabel, CommonResources.UnitInSeconds);
    }

    public get color(): string {
        return TestReportColorPalette.Duration;
    }

    public get allowDecimal(): boolean {
        return true;
    }

    public get values(): number[] {
        return this._data.map(d => {
            return TestReportDataParser.getCustomizedDecimalValue(d, 2);
        });
    }
}
